import { parsedUser } from "../../utils/GetCurrentUser";
import { useToast } from "../../contexts/toast";
import { useEffect, useState, useMemo } from "react";
import API from "../../api/api";
import { useParams, useLocation } from "react-router-dom";
import { Dropdown, Modal } from "react-bootstrap";
import useFavorite from "../../hooks/useFavorite";
import { useApiResponseHandler } from "../../hooks/useApiResponseHandler";
import PieChart, { Label, Legend, Series, Connector, Font } from "devextreme-react/pie-chart";
import Chart, {
  ArgumentAxis,
  ValueAxis,
  CommonSeriesSettings,
  Series as ChartSeries,
  Tooltip,
  Legend as ChartLegend,
  Grid,
  Point,
  Label as ChartLabel,
  Format,
  Tick
} from "devextreme-react/chart";
import { CustomBreadcrumbs as Breadcrumbs } from "../../components";
import "./GenericDashboard.css";

// Componente personalizado para el botón de cerrar modal
const CustomCloseButton = ({ onClose }) => {
  
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      style={{
        border: "1px solid #b0b0b0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        backgroundColor: isHovered ? "#ff4136" : "",
        cursor: "pointer"
      }}
      className="btn"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClose}
      aria-label="Close"
    >
      <i 
        style={{ 
          fontSize: "20px", 
          color: isHovered ? "#ffffff" : "#b0b0b0",
          transition: "color 0.2s ease"
        }} 
        className="fa-solid fa-xmark"
      ></i>
    </button>
  );
};

// Componente personalizado para el botón de maximizar
const CustomMaximizeButton = ({ onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      className="btn btn-sm rounded"
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        border: '1px solid rgba(0, 0, 0, 0.15)',
        transition: 'all 0.2s ease',
        marginLeft: '10px',
        fontSize: '17px',
        backgroundColor: isHovered ? 'rgba(0, 123, 255, 0.08)' : 'transparent',
        transform: isHovered ? 'scale(1.05)' : 'scale(1)',
      }}
      title="Maximizar gráfico"
    >
      <i 
        className="fa-sharp fa-thin fa-arrow-up-right-and-arrow-down-left-from-center" 
        style={{ 
          color: isHovered ? 'rgba(0, 123, 255, 0.9)' : 'rgba(0, 0, 0, 0.6)',
          transition: 'color 0.2s ease'
        }}
      ></i>
    </button>
  );
};

const GenericDashboard = () => {

    const user = parsedUser();
  const toast = useToast();
  const { pathname } = useLocation();
  const { isPinned, UpdateFavorites, checkIfPinned } = useFavorite();
  const { handleApiResponse, ErrorModal } = useApiResponseHandler();

  const [gridConfig, setGridConfig] = useState(null);
  const [chartItems, setChartItems] = useState([]);
  const [formTitle, setFormTitle] = useState("");
  const [formPath, setFormPath] = useState("");
  const [formIcon, setFormIcon] = useState("");
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  // Estados para el modal de maximizar gráficos
  const [isChartMaximized, setIsChartMaximized] = useState(false);
  const [currentChartIndex, setCurrentChartIndex] = useState(0);
  const [chartsForNavigation, setChartsForNavigation] = useState([]);
  const [isAutoPlayActive, setIsAutoPlayActive] = useState(false);

  const { id } = useParams();

  // Función helper para obtener propiedades según el modo (Card o Full)
  const getItemProperties = (item, mode = "Card") => {
    if (!item.ItemProperties || !Array.isArray(item.ItemProperties)) {
      // Fallback a propiedades antiguas si no existe ItemProperties
      return {
        Legend: false,
        ConnectorVisible: item.ItemConnectorVisible === "true",
        ConnectorWidth: parseFloat(item.ItemConnectorWidth) || 0,
        LabelVisible: true,
        LabelFontSize: "11px",
        LabelPosition: item.LabelPosition || "inside",
        ItemPadding: item.ItemPadding || "10px"
      };
    }

    const modeProperties = item.ItemProperties.find(prop => prop.ItemMode === mode);
    if (modeProperties && modeProperties.Properties) {
      return {
        Legend: modeProperties.Properties.Legend === "true" || modeProperties.Properties.Legend === true,
        ConnectorVisible: modeProperties.Properties.ConnectorVisible === true,
        ConnectorWidth: modeProperties.Properties.ConnectorWidth || 0,
        LabelVisible: modeProperties.Properties.LabelVisible === true || modeProperties.Properties.LabelVisible === "true",
        LabelFontSize: modeProperties.Properties.LabelFontSize || "11px",
        LabelPosition: modeProperties.Properties.LabelPosition || item.LabelPosition || "inside",
        ItemPadding: modeProperties.Properties.ItemPadding || item.ItemPadding || "10px",
        TableData: modeProperties.Properties.TableData === true
      };
    }

    // Fallback por defecto
    return {
      Legend: false,
      ConnectorVisible: false,
      ConnectorWidth: 0,
      LabelVisible: true,
      LabelFontSize: "11px",
      LabelPosition: "inside",
      ItemPadding: "10px",
      TableData: false
    };
  };

  const CustomPieChart = ({data, fontColor, properties}) => {

    const customizeLabel = (pointInfo) => {
      return `${pointInfo.argumentText}: ${pointInfo.valueText}`;
    };

    const customizePoint = (pointInfo) => {
      if (pointInfo.data && pointInfo.data.color) {
        return { color: pointInfo.data.color };
      }
      return {};
    };

      
      console.log("🔍 Pie Chart data:", data);
      console.log("🔍 Pie Chart properties:", properties);

      if (data === undefined) {
          return <div>No data</div>;
      }
    return (
        <PieChart
            dataSource={data}
            resolveLabelOverlapping="shift"
            innerRadius={0.65}
            type="doughnut"
            customizePoint={customizePoint}
            height="100%"
            width="100%"
          >
            <Series argumentField="category" valueField="value">
              <Label
                visible={properties.LabelVisible}
                format="fixedPoint"
                customizeText={customizeLabel}
                position={properties.LabelPosition}
                font={{
                  size: parseInt(properties.LabelFontSize) || 11,
                  weight: 700,
                  color: fontColor
                }}
              >
                {properties.ConnectorVisible && (
                  <Connector visible={true} width={properties.ConnectorWidth}></Connector>
                )}
              </Label>
            </Series>

            <Legend visible={properties.Legend} />
          </PieChart>
    )
  }

  const CustomBarChart = ({chartData, seriesConfig}) => {
    console.log("🔍 Bar Chart chartData:", chartData);
    console.log("🔍 Bar Chart seriesConfig:", seriesConfig);

    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return <div>No data</div>;
    }

    if (!seriesConfig || !Array.isArray(seriesConfig) || seriesConfig.length === 0) {
      return <div>No series configuration</div>;
    }

    // Colores por tipo de stack (fallback si no viene Color del backend)
    const getColorBySeries = (field, stack) => {
      // Entradas en tonos verdes
      if (stack === "Entradas") {
        return field.includes("H") ? "#4CAF50" : "#8BC34A"; // Hombres verde oscuro, Mujeres verde claro
      }
      // Salidas en tonos rojos
      if (stack === "Salidas") {
        return field.includes("H") ? "#F44336" : "#EF5350"; // Hombres rojo oscuro, Mujeres rojo claro
      }
      return "#999999";
    };

    return (
      <Chart
        dataSource={chartData}
        height="100%"
        width="100%"
      >
        {seriesConfig.map((serie, index) => (
          <ChartSeries
            key={index}
            valueField={serie.Field}
            name={serie.Title}
            type="bar"
            stack={serie.Stack}
            color={serie.Color || getColorBySeries(serie.Field, serie.Stack)}
          />
        ))}

        <CommonSeriesSettings
          argumentField="Mes"
          type="bar"
          ignoreEmptyPoints={true}
        />

        <ArgumentAxis>
          <Label rotationAngle={-45} overlappingBehavior="rotate" />
        </ArgumentAxis>

        <ValueAxis>
          <Label format="fixedPoint" />
        </ValueAxis>

        <ChartLegend
          verticalAlignment="bottom"
          horizontalAlignment="center"
        />

        <Tooltip
          enabled={true}
          customizeTooltip={(pointInfo) => ({
            text: `${pointInfo.seriesName}: ${pointInfo.valueText}`
          })}
        />
      </Chart>
    );
  }

  // Función para renderizar Items tipo Card
  const renderCardItem = (item, hasGridConfig) => {
    // Verificar si ItemData tiene la nueva estructura (Grid e Items) o la antigua (array directo)
    const hasNewStructure = item.ItemData && !Array.isArray(item.ItemData) && item.ItemData.Items;
    const cards = hasNewStructure ? item.ItemData.Items : (Array.isArray(item.ItemData) ? item.ItemData : []);
    
    // Si el item tiene GridRow con span 4 o más, son cards verticales de estado
    const isVerticalList = item.GridRow && (item.GridRow.includes('span 4') || item.GridRow.includes('span 6'));
    
    if (isVerticalList) {
      return (
        <>
          {cards.map((card, index) => (
            <div 
              key={index} 
              className="estado-card-container"
              style={{
                // Si tiene grid y Width/Height son "span X", usar grid positioning
                // Si no, usar width/height normales
                ...(hasGridConfig && card.Width?.includes('span') ? { gridColumn: card.Width } : { width: card.Width }),
                ...(hasGridConfig && card.Height?.includes('span') ? { gridRow: card.Height } : { height: card.Height })
              }}
            >
              <div className="estado-card" style={{ backgroundColor: card.BackColor }}>
                <div className="estado-icon" style={{ color: card.ForeColor }}>
                  <i className={card.Icon}></i>
                </div>
                <div className="estado-text" style={{ color: card.ForeColor }}>{card.Kpi}</div>
              </div>
              <div className="estado-value" style={{ backgroundColor: card.ForeColor }}>
                {card.Valor}
              </div>
            </div>
          ))}
        </>
      );
    }

    // Cards horizontales normales (header)
    return (
      <>
        {cards.map((card, index) => (
          <div 
            key={index}
            className="general-card-item"
            style={{ 
              // Si tiene grid y Width/Height son "span X", usar grid positioning
              // Si no, usar width/height normales
              ...(hasGridConfig && card.Width?.includes('span') ? { gridColumn: card.Width } : { width: card.Width }),
              ...(hasGridConfig && card.Height?.includes('span') ? { gridRow: card.Height } : { height: card.Height })
            }}
          >
            <div
              className="general-stat-card"
              style={{ backgroundColor: card.BackColor }}
            >
              <div
                className="general-card-header"
                style={{ backgroundColor: card.ForeColor, color: card.BackColor }}
              >
                {card.Kpi}
              </div>
              <div className="general-card-body">
                <div
                  className="general-card-icon"
                  style={{ color: card.ForeColor }}
                >
                  <i className={card.Icon}></i>
                </div>
                <div
                  className="general-card-value"
                  style={{ color: card.ForeColor }}
                >
                  {card.Valor}
                </div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };

  // Función para renderizar Items tipo Pies (múltiples gráficos de dona)
  const renderPiesItem = (item, showMaximizeButton = false, onMaximize = null, mode = "Card") => {
    // Obtener propiedades según el modo
    const properties = getItemProperties(item, mode);
    
    return (
      <div 
        className="p-3"
        style={{ borderRadius: 15, height: '100%' }}
      >

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
          <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.ItemTitle}</h5>
          {showMaximizeButton && onMaximize && (
            <CustomMaximizeButton onClick={onMaximize} />
          )}
        </div>
        
        <div 
          className="chart-donut-container"
          style={{
            padding: properties.ItemPadding
          }}
        >
          {item.ItemData.map((serieData, index) => (
            <div key={index} className="donut-item">
              <div style={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column' }}>
                <h6 style={{ marginBottom: '5px', fontWeight: 600, color: '#3d4d5c', fontSize: '12px', flexShrink: 0 }}>
                  {serieData.Serie}
                </h6>
                <PieChart
                  dataSource={serieData.Data.map(d => ({
                    category: d.Kpi,
                    value: d.Valor,
                    color: d.BackColor
                  }))}
                  resolveLabelOverlapping="shift"
                  innerRadius={0.7}
                  type="doughnut"
                  customizePoint={(pointInfo) => ({ color: pointInfo.data.color })}
                >
                  <Series argumentField="category" valueField="value">
                    <Label
                      visible={properties.LabelVisible}
                      format="fixedPoint"
                      customizeText={(pointInfo) => `${pointInfo.argumentText}: ${pointInfo.valueText}`}
                      position={properties.LabelPosition || "columns"}
                    >
                      {properties.ConnectorVisible && (
                        <Connector visible={true} width={properties.ConnectorWidth}></Connector>
                      )}
                      <Font size={parseInt(properties.LabelFontSize) || 10} weight={600} color="#FFFFFF" />
                    </Label>
                  </Series>
                  <Legend visible={properties.Legend} />
                </PieChart>
              </div>
            </div>
          ))}
        </div>
        </div>
    );
  };

  // Función para renderizar gráfico tipo Spline (líneas múltiples con doble eje Y)
  const renderSplineChart = (chartData, seriesConfig) => {
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return <div>No data</div>;
    }

    if (!seriesConfig || !Array.isArray(seriesConfig) || seriesConfig.length === 0) {
      return <div>No series configuration</div>;
    }

    return (
      <Chart
        dataSource={chartData}
        style={{ height: "100%" }}
      >
        <CommonSeriesSettings
          argumentField="Periodo"
          type="spline"
        >
          <Point hoverMode="allArgumentPoints" />
        </CommonSeriesSettings>

        {seriesConfig.map((serie, index) => (
          <ChartSeries
            key={index}
            valueField={serie.Serie}
            name={serie.Kpi}
            color={serie.Color}
            axis={serie.Group === 2 ? "secondary" : "primary"}
          />
        ))}

        <ArgumentAxis>
          <Grid visible={true} />
        </ArgumentAxis>

        <ValueAxis name="primary">
          <Grid visible={true} />
        </ValueAxis>

        <ValueAxis name="secondary" position="right">
          <Grid visible={false} />
        </ValueAxis>

        <ChartLegend
          verticalAlignment="bottom"
          horizontalAlignment="center"
        />

        <Tooltip enabled={true} />
      </Chart>
    );
  };

  // Función para renderizar gráfico tipo Stacked (barras horizontales apiladas)
  const renderStackedChart = (chartData, seriesConfig) => {
    console.log("🔍 Stacked Chart Data:", chartData);
    console.log("🔍 Stacked Series Config:", seriesConfig);
    
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return <div>No data</div>;
    }

    if (!seriesConfig || !Array.isArray(seriesConfig) || seriesConfig.length === 0) {
      return <div>No series configuration</div>;
    }

    // Filtrar series duplicadas por Serie (valueField)
    const uniqueSeries = seriesConfig.reduce((acc, serie) => {
      if (!acc.find(s => s.Serie === serie.Serie)) {
        acc.push(serie);
      }
      return acc;
    }, []);

    console.log("🔍 Unique Series:", uniqueSeries);

    return (
      <Chart
        dataSource={chartData}
        style={{ height: "100%" }}
        rotated={id === "bc61cfe4d54f23faad5f1ced4d081c36ee0a54243d0f203c49bbb128506c1d758b044ca0149cbeed7ad4337c1814f3d7795115534bb5651eab7b5ec1ece36b98"}
      >
        <CommonSeriesSettings
          argumentField="Periodo"
          type="stackedBar"
        />

        {uniqueSeries.map((serie, index) => (
          <ChartSeries
            key={index}
            valueField={serie.Serie}
            name={serie.Kpi}
            color={serie.Color}
            stack="total"
          />
        ))}

        <ArgumentAxis>
          <Grid visible={false} />
        </ArgumentAxis>

        <ValueAxis>
          <Grid visible={true} />
        </ValueAxis>

        <ChartLegend
          visible={true}
          verticalAlignment="bottom"
          horizontalAlignment="center"
          itemTextPosition="right"
        />

        <Tooltip enabled={true} />
      </Chart>
    );
  };

  // Función para renderizar gráfico tipo Clustered (barras verticales agrupadas)
  const renderClusteredChart = (chartData, seriesConfig) => {
    if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
      return <div>No data</div>;
    }

    if (!seriesConfig || !Array.isArray(seriesConfig) || seriesConfig.length === 0) {
      return <div>No series configuration</div>;
    }

    return (
      <Chart
        dataSource={chartData}
        style={{ height: "100%" }}
      >
        <CommonSeriesSettings
          argumentField="Periodo"
          type="bar"
        />

        {seriesConfig.map((serie, index) => (
          <ChartSeries
            key={index}
            valueField={serie.Serie}
            name={serie.Kpi}
            color={serie.Color}
          />
        ))}

        <ArgumentAxis>
          <Grid visible={false} />
        </ArgumentAxis>

        <ValueAxis>
          <Grid visible={true} />
        </ValueAxis>

        <ChartLegend
          verticalAlignment="bottom"
          horizontalAlignment="center"
        />

        <Tooltip enabled={true} />
      </Chart>
    );
  };

  // Función para renderizar Items tipo StackedBar (barras horizontales apiladas con labels)
  const renderStackedBarItem = (item) => {
    if (!item.ItemData || !item.ItemData[0]) return null;

    const chartData = item.ItemData[0];
    const series = chartData.Series;
    const data = chartData.Data.map(d => {
      const dataPoint = { name: d.Kpi };
      series.forEach(s => {
        dataPoint[s.Serie] = d[s.Serie];
      });
      return dataPoint;
    });

    return (
      <Chart
        dataSource={data}
        rotated={true}
        barGroupPadding={0.2}
        style={{ height: "100%" }}
      >
        <CommonSeriesSettings
          argumentField="name"
          type="stackedBar"
          hoverMode="allArgumentPoints"
          selectionMode="allArgumentPoints"
        >
          <ChartLabel visible={true}>
            <Format type="fixedPoint" precision={0} />
            <Font size={14} weight={600} />
          </ChartLabel>
        </CommonSeriesSettings>

        {series.map((serie, index) => (
          <ChartSeries 
            key={index}
            valueField={serie.Serie} 
            name={serie.Kpi}
            color={serie.Color} 
            stack="total" 
          />
        ))}

        <ArgumentAxis>
          <Font size={12} />
        </ArgumentAxis>

        <ValueAxis>
          <Tick visible={true} />
        </ValueAxis>

        <ChartLegend visible={false} />
      </Chart>
    );
  };

  // Funciones para el modal de maximizar gráficos
  const openChartMaximized = (chartIndex) => {
    // Filtrar solo los gráficos que no sean Card
    const nonCardCharts = chartItems.filter(item => item.type !== "Card");
    setChartsForNavigation(nonCardCharts);
    
    // Encontrar el índice del gráfico seleccionado en la lista filtrada
    const selectedChartIndexInFiltered = nonCardCharts.findIndex(
      chart => chart.itemIndex === chartItems[chartIndex].itemIndex
    );
    
    setCurrentChartIndex(selectedChartIndexInFiltered);
    setIsChartMaximized(true);
  };

  const closeChartMaximized = () => {
    setIsChartMaximized(false);
    setIsAutoPlayActive(false); // Desactivar autoplay al cerrar
  };

  const goToPreviousChart = () => {
    setCurrentChartIndex((prev) => (prev > 0 ? prev - 1 : chartsForNavigation.length - 1));
  };

  const goToNextChart = () => {
    setCurrentChartIndex((prev) => (prev < chartsForNavigation.length - 1 ? prev + 1 : 0));
  };

  // Función para renderizar tabla de datos para gráficos con series (Stacked, Clustered, etc.)
  const renderDataTable = (data, seriesConfig) => {
    if (!data || !Array.isArray(data) || data.length === 0) return null;
    if (!seriesConfig || !Array.isArray(seriesConfig) || seriesConfig.length === 0) return null;

    // Obtener series únicas por Serie (para evitar duplicados)
    const uniqueSeriesMap = new Map();
    seriesConfig.forEach(serie => {
      const key = serie.Serie || serie.Field;
      if (!uniqueSeriesMap.has(key)) {
        uniqueSeriesMap.set(key, {
          field: key,
          title: serie.Kpi || serie.Title,
          color: serie.Color
        });
      }
    });
    const columns = Array.from(uniqueSeriesMap.values());

    // Agrupar datos por Periodo/Mes/name/Kpi
    const groupedData = new Map();
    data.forEach(row => {
      const key = row.Periodo || row.Mes || row.name || row.Kpi;
      if (!groupedData.has(key)) {
        groupedData.set(key, { 
          Periodo: row.Periodo, 
          Mes: row.Mes, 
          name: row.name,
          Kpi: row.Kpi,
          label: key // Etiqueta para mostrar
        });
      }
      // Agregar valores de cada serie al key
      columns.forEach(col => {
        if (row[col.field] !== undefined && row[col.field] !== null) {
          groupedData.get(key)[col.field] = row[col.field];
        }
      });
    });

    const tableData = Array.from(groupedData.values());

    // Calcular totales por columna
    const totals = {};
    columns.forEach(col => {
      totals[col.field] = tableData.reduce((sum, row) => {
        const value = row[col.field];
        return sum + (value !== undefined && value !== null && !isNaN(value) ? Number(value) : 0);
      }, 0);
    });

    return (
      <div style={{ 
        borderRadius: '8px',
        maxHeight: '100%',
        overflowY: 'auto',
        minWidth: '300px',
        border: '1px solid #e0e0e0'
      }}>
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse',
          fontSize: '1.2rem',
        }}>
          <thead>
            <tr style={{ borderBottom: '1px solid #e0e0e0' }}>
              <th style={{ 
                padding: '8px', 
                textAlign: 'left',
                color: '#000',
              }}></th>
              {columns.map((col, index) => (
                <th key={index} style={{ 
                  padding: '16px 8px', 
                  textAlign: 'center',
                  color: '#000',
                  backgroundColor: col.color,
                  width: '80px',
                  minWidth: '80px',
                  maxWidth: '80px'
                }}>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, rowIndex) => (
              <tr key={rowIndex} style={{ 
                borderBottom: '1px solid #ccc',
              }}>
                <td style={{ 
                  padding: '8px',
                  color: '#000',
                  textAlign: 'center',
                  borderRight: '1px solid #e0e0e0'
                }}>{row.label || row.Periodo || row.Mes || row.name || row.Kpi || '-'}</td>
                {columns.map((col, colIndex) => (
                  <td key={colIndex} style={{ 
                    padding: '8px', 
                    textAlign: 'center',
                    color: '#000',
                    width: '80px',
                    minWidth: '80px',
                    maxWidth: '80px'
                  }}>
                    {row[col.field] !== undefined && row[col.field] !== null ? row[col.field] : '-'}
                  </td>
                ))}
              </tr>
            ))}
            {/* Fila de totales */}
            <tr style={{ 
              borderTop: '2px solid #333',
              backgroundColor: '#f5f5f5'
            }}>
              <td style={{ 
                padding: '8px',
                color: '#000',
                textAlign: 'center',
                fontWeight: 'bold',
                borderRight: '1px solid #e0e0e0'
              }}>TOTAL</td>
              {columns.map((col, colIndex) => (
                <td key={colIndex} style={{ 
                  padding: '8px', 
                  textAlign: 'center',
                  color: '#000',
                  fontWeight: 'bold',
                  width: '80px',
                  minWidth: '80px',
                  maxWidth: '80px'
                }}>
                  {totals[col.field] !== undefined ? Number(totals[col.field].toFixed(2)) : '-'}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  // Función para renderizar tabla de datos para gráficos Pie
  const renderPieDataTable = (data) => {
    if (!data || !Array.isArray(data) || data.length === 0) return null;

    return (
      <div style={{ 
        borderRadius: '8px',
        maxHeight: '100%',
        overflowY: 'auto',
        minWidth: '300px',
        border: '1px solid #e0e0e0'
      }}>
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse',
          fontSize: '1.2rem',
        }}>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex} style={{ 
                borderBottom: rowIndex < data.length - 1 ? '1px solid #ccc' : 'none',
              }}>
                <td style={{ 
                  padding: '8px',
                  color: '#000',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <div style={{
                    width: '16px',
                    height: '16px',
                    backgroundColor: row.color,
                    borderRadius: '3px',
                    border: '1px solid #ccc'
                  }}></div>
                  {row.category || '-'}
                </td>
                <td style={{ 
                  padding: '8px', 
                  textAlign: 'center',
                  color: '#000',
                  width: '80px',
                  minWidth: '80px',
                  maxWidth: '80px'
                }}>
                  {row.value !== undefined && row.value !== null ? row.value : '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // Función para renderizar tabla de datos para gráficos Pies (múltiples series)
  const renderPiesDataTable = (itemData) => {
    if (!itemData || !Array.isArray(itemData) || itemData.length === 0) return null;

    return (
      <div style={{ 
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        maxHeight: '100%',
        overflowY: 'auto'
      }}>
        {itemData.map((serieData, serieIndex) => {
          // Calcular total para esta serie
          let serieTotal = 0;
          if (serieData.Data && Array.isArray(serieData.Data)) {
            serieTotal = serieData.Data.reduce((sum, row) => {
              const valor = row.Valor !== undefined && row.Valor !== null && !isNaN(row.Valor) ? Number(row.Valor) : 0;
              return sum + valor;
            }, 0);
          }

          return (
            <div 
              key={serieIndex} 
              style={{ 
                borderRadius: '8px',
                border: '1px solid #e0e0e0',
                minWidth: '300px'
              }}
            >
              {/* Tabla de la serie */}
              <table style={{ 
                width: '100%', 
                borderCollapse: 'collapse',
                fontSize: '1.2rem',
              }}>
                <tbody>
                  {serieData.Data && serieData.Data.map((row, rowIndex) => (
                    <tr key={rowIndex} style={{ 
                      borderBottom: '1px solid #ccc',
                    }}>
                      <td style={{ 
                        padding: '8px',
                        color: '#000',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                        <div style={{
                          width: '16px',
                          height: '16px',
                          backgroundColor: row.BackColor,
                          borderRadius: '3px',
                          border: '1px solid #ccc'
                        }}></div>
                        {row.Kpi || '-'}
                      </td>
                      <td style={{ 
                        padding: '8px', 
                        textAlign: 'center',
                        color: '#000',
                        width: '80px',
                        minWidth: '80px',
                        maxWidth: '80px'
                      }}>
                        {row.Valor !== undefined && row.Valor !== null ? row.Valor : '-'}
                      </td>
                    </tr>
                  ))}
                  
                  {/* Fila de totales para esta serie */}
                  <tr style={{ 
                    borderTop: '2px solid #333',
                    backgroundColor: '#f5f5f5'
                  }}>
                    <td style={{ 
                      padding: '8px',
                      color: '#000',
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      TOTAL
                    </td>
                    <td style={{ 
                      padding: '8px', 
                      textAlign: 'center',
                      color: '#000',
                      fontWeight: 'bold',
                      width: '80px',
                      minWidth: '80px',
                      maxWidth: '80px'
                    }}>
                      {Number(serieTotal.toFixed(2))}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    );
  };

  // Función para renderizar el contenido del gráfico en el modal
  const renderMaximizedChart = (item) => {
    if (!item) return null;

    // Obtener propiedades de "Full" mode para gráficos maximizados
    const fullProperties = item.rawItem ? getItemProperties(item.rawItem, "Full") : null;
    
    console.log("🔍 Maximized Chart - Item Type:", item.type);
    console.log("🔍 Maximized Chart - Full Properties:", fullProperties);
    console.log("🔍 Maximized Chart - TableData:", fullProperties?.TableData);
    console.log("🔍 Maximized Chart - Item Data:", item.data);
    console.log("🔍 Maximized Chart - Series Config:", item.seriesConfig);
    console.log("🔍 Maximized Chart - Raw Item:", item.rawItem);
    
    // Para gráficos tipo Pie y Pies, solo necesitamos data
    const isPieType = item.type === "Pie";
    const isPiesType = item.type === "Pies";
    
    // Para otros gráficos, necesitamos data y seriesConfig
    let hasDataForTable = false;
    if (isPieType) {
      hasDataForTable = item.data && Array.isArray(item.data) && item.data.length > 0;
    } else if (isPiesType) {
      hasDataForTable = item.rawItem && item.rawItem.ItemData && Array.isArray(item.rawItem.ItemData) && item.rawItem.ItemData.length > 0;
    } else {
      hasDataForTable = item.data && Array.isArray(item.data) && item.data.length > 0 &&
                       item.seriesConfig && Array.isArray(item.seriesConfig) && item.seriesConfig.length > 0;
    }
    
    // La tabla se muestra para TODOS los tipos de gráfico excepto Card
    // Solo si TableData es true en las propiedades de modo Full
    const canShowTable = fullProperties?.TableData === true && 
                        item.type !== "Card" &&
                        hasDataForTable;
    
    console.log("🔍 Can Show Table:", canShowTable, "| hasDataForTable:", hasDataForTable, "| isPieType:", isPieType, "| isPiesType:", isPiesType);

    return (
      <div style={{ 
        width: "100%", 
        height: "100%", 
        display: "flex", 
        flexDirection: canShowTable ? "row" : "column",
        gap: canShowTable ? "20px" : "0"
      }}>
        {/* Contenedor del gráfico */}
        <div style={{ 
          flex: canShowTable ? "1" : "1",
          minHeight: 0,
          minWidth: 0,
          display: "flex",
          flexDirection: "column"
        }}>
          {item.type === "Pies" && renderPiesItem(item.rawItem, false, null, "Full")}
          
          {item.type === "Spline" && (
            <div style={{ flex: 1, minHeight: 0, padding: fullProperties?.ItemPadding || item.itemPadding || "16px" }}>
              {renderSplineChart(item.data, item.seriesConfig)}
            </div>
          )}
          
          {item.type === "Stacked" && (
            <div style={{ flex: 1, minHeight: 0, padding: fullProperties?.ItemPadding || item.itemPadding || "16px" }}>
              {renderStackedChart(item.data, item.seriesConfig)}
            </div>
          )}
          
          {item.type === "Clustered" && (
            <div style={{ flex: 1, minHeight: 0, padding: fullProperties?.ItemPadding || item.itemPadding || "16px" }}>
              {renderClusteredChart(item.data, item.seriesConfig)}
            </div>
          )}
          
          {item.type === "StackedBar" && (
            <div style={{ flex: 1, minHeight: 0, padding: fullProperties?.ItemPadding || item.itemPadding || "16px" }}>
              {renderStackedBarItem(item.rawItem)}
            </div>
          )}
          
          {item.type !== "Card" && item.type !== "Pies" && item.type !== "Spline" && item.type !== "Stacked" && item.type !== "Clustered" && item.type !== "StackedBar" && (
            <div style={{ 
              flex: 1, 
              minHeight: 0, 
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center", 
              justifyContent: "center", 
              width: "100%",
              padding: fullProperties?.ItemPadding || (item.type === "Pie" && item.itemPadding ? item.itemPadding : "16px")
            }}>
              {item.type === "Pie" && fullProperties && <CustomPieChart 
                data={item.data} 
                fontColor={item.isEstado ? undefined : "#FFFFFF"} 
                properties={fullProperties}
              />}
              {item.type === "ClusteredStacked" && <CustomBarChart chartData={item.data} seriesConfig={item.seriesConfig} />}
            </div>
          )}
        </div>

        {/* Tabla de datos (cuando TableData es true) */}
        {canShowTable && (
          <div style={{ 
            width: '500px',
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column'
          }}>
            {isPieType 
              ? renderPieDataTable(item.data)
              : isPiesType
              ? renderPiesDataTable(item.rawItem.ItemData)
              : renderDataTable(item.data, item.seriesConfig)}
          </div>
        )}
      </div>
    );
  };

    const getDataDashboard = async () => {
        try {
          setIsRefreshing(true);
          console.log("🔍 Obteniendo datos del Dashboard de Alojamientos...");
    
          // Enviar Token e IdUser como enteros
          const query = `Token=${user.Token}&IdUser=${user.IdUser}&id=${id}`;
    
          const response = await API.getAction(`api/OcupacionProcesos/Dashboard?${query}`, null);
    
          console.log("📊 Dashboard Response:", response.data);
    
          if (response.data && response.data.length > 0) {
            // Parsear el primer nivel de JSONData
            let firstLevel = JSON.parse(response.data[0].JSONData);
            console.log("📋 Primera capa Dashboard (parseada):", firstLevel);
    
            // Verificar errores y manejar con el handler estandarizado
            const parsedResults = Array.isArray(firstLevel) ? firstLevel[0] : firstLevel;
            if (parsedResults && (parsedResults.Error || parsedResults.Logout || parsedResults.Expired)) {
              if (handleApiResponse(parsedResults)) {
                return;
              }
            }
    
            const dashboardData = firstLevel.DashboardData;
    
            // Extraer información del formulario (si existe)
            if (dashboardData.FormTitle) {
              setFormTitle(dashboardData.FormTitle);
            }
            if (dashboardData.FormPath) {
              setFormPath(dashboardData.FormPath);
            }
            if (dashboardData.FormIcon) {
              setFormIcon(dashboardData.FormIcon);
            }
    
            // Configuración del Grid
            if (dashboardData.Grid) {
              setGridConfig(dashboardData.Grid);
              console.log("✅ Grid config cargada:", dashboardData.Grid);
            }
    
            // Procesar Items
            if (dashboardData.Items && dashboardData.Items.length > 0) {
              const mappedItems = dashboardData.Items.map(item => {
                // Para los gráficos de Estado y Área de Personal, invertir los colores
                const isSpecialChart = item.ItemTitle === "Estado" || item.ItemTitle === "Area de Personal";
                
                let chartData;
                let seriesConfig = null;
                
                // Procesamiento específico según el tipo de gráfico
                if (item.ItemType === "ClusteredStacked" || item.ItemType === "Spline" || item.ItemType === "Clustered" || item.ItemType === "Stacked" || item.ItemType === "StackedBar") {
                  // El formato es: ItemData[0].Series y ItemData[0].Data
                  if (item.ItemData && item.ItemData.length > 0 && item.ItemData[0].Series && item.ItemData[0].Data) {
                    seriesConfig = item.ItemData[0].Series;
                    chartData = item.ItemData[0].Data;
                  } else {
                    chartData = [];
                    seriesConfig = [];
                  }
                } else if (item.ItemType === "Card" || item.ItemType === "Pies") {
                  // Card y Pies se pasan directamente sin transformar
                  chartData = item.ItemData;
                } else {
                  // Procesamiento para gráficos Pie
                  chartData = item.ItemData.map(dataItem => ({
                    category: dataItem.Kpi,
                    value: parseInt(dataItem.Valor),
                    // Estado y Área de Personal usan ForeColor para background, los demás usan BackColor
                    color: isSpecialChart ? dataItem.ForeColor : (dataItem.BackColor || dataItem.ForeColor),
                    // Guardar ambos colores para gráficos especiales
                    textColor: isSpecialChart ? dataItem.BackColor : undefined
                  }));
                }

                return {
                  itemIndex: item.ItemIndex,
                  title: item.ItemTitle,
                  type: item.ItemType,
                  gridRow: item.GridRow,
                  gridCol: item.GridCol,
                  data: chartData,
                  seriesConfig: seriesConfig,
                  isEstado: isSpecialChart,
                  rawItem: item, // Guardar el item completo para acceder a ItemProperties
                  // Propiedades antiguas como fallback (para compatibilidad)
                  labelPosition: item.LabelPosition,
                  connectorVisible: item.ItemConnectorVisible,
                  connectorWidth: item.ItemConnectorWidth,
                  itemPadding: item.ItemPadding,
                  // Incluir ItemProperties si existe
                  itemProperties: item.ItemProperties
                };
              });
    
              setChartItems(mappedItems);
              console.log("✅ Items cargados:", mappedItems.length, "gráficos");
            }
    
          } else {
            console.warn("⚠️ No se recibieron datos para el dashboard.");
            toast({
              type: "info",
              message: "No hay datos disponibles para mostrar"
            });
          }
    
        } catch (error) {
          console.error("❌ Error al obtener datos del Dashboard:", error);
          toast({
            type: "error",
            message: "No se pudieron cargar los datos del dashboard"
          });
        } finally {
          setIsRefreshing(false);
        }
      };

      const addFavorite = async () => {
        const newFavorite = {
          icon: `${formIcon}`,
          path: pathname,
          formPath: formPath,
          title: formTitle,
        }
        UpdateFavorites(newFavorite)
      }

      useEffect(() => {
        if (user && user.Token && user.IdUser && id) {
          // Limpiar datos anteriores antes de cargar nuevos
          setGridConfig(null);
          setChartItems([]);
          setFormTitle("");
          setFormPath("");
          setFormIcon("");
          setIsRefreshing(false);
          // Verificar si la pantalla está en favoritos
          checkIfPinned();
          getDataDashboard();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [id]);

      // useEffect para manejar el autoplay de gráficos
      useEffect(() => {
        let intervalId;
        
        if (isAutoPlayActive && isChartMaximized && chartsForNavigation.length > 1) {
          intervalId = setInterval(() => {
            setCurrentChartIndex((prev) => 
              prev < chartsForNavigation.length - 1 ? prev + 1 : 0
            );
          }, 10000); // 10 segundos
        }

        return () => {
          if (intervalId) {
            clearInterval(intervalId);
          }
        };
      }, [isAutoPlayActive, isChartMaximized, chartsForNavigation.length]);

      const breadcrumbColor = localStorage.getItem('COLOR_BREADCRUMB');

  // Memorizar el contenido del gráfico maximizado para evitar re-renders cuando cambia isAutoPlayActive
  const maximizedChartContent = useMemo(() => {
    if (!isChartMaximized || chartsForNavigation.length === 0) return null;
    
    return (
      <div style={{ 
        width: '100%',
        height: '100%', 
        backgroundColor: '#ffffff',
        borderRadius: '15px',
        padding: '20px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {renderMaximizedChart(chartsForNavigation[currentChartIndex])}
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isChartMaximized, currentChartIndex, chartsForNavigation]);

  return (
    <>
      <Breadcrumbs pathTitle={formPath || "Dashboard"} />

      {formTitle && (
        <div className="row mx-0">
          <div className="d-flex align-items-center justify-content-between my-1">
            <div className="d-flex align-items-center">
              {formIcon && <i className={formIcon + " me-3 fa-2x"}></i>}
              <div className="d-flex flex-column">
                <h5 className={"my-1"}>{formTitle}</h5>
              </div>
            </div>
            {/* BOTÓN DE ACTUALIZAR Y MENÚ */}
            <div className="d-flex align-items-center gap-2">
              <button
                onClick={getDataDashboard}
                disabled={isRefreshing}
                style={{
                  padding: '10px 20px',
                  backgroundColor: isRefreshing ? '#cccccc' : '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: isRefreshing ? 'not-allowed' : 'pointer',
                  fontSize: '14px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                <i className={`fas fa-sync-alt ${isRefreshing ? 'fa-spin' : ''}`}></i>
                {isRefreshing ? 'Actualizando...' : 'Actualizar Datos'}
              </button>
              <Dropdown>
                    <Dropdown.Toggle variant="button" id="dropdown-basic">
                      <i className="fa fa-ellipsis-v" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      {isPinned ? <Dropdown.Item onClick={() => { addFavorite() }} style={{ fontWeight: 400 }}><i className="fa-thin fa-bookmark-slash" style={{ fontSize: '1.2rem' }}></i>  Remover de favoritos</Dropdown.Item> : <Dropdown.Item onClick={() => { addFavorite() }} style={{ fontWeight: 400 }}><i className="fa-thin fa-bookmark" style={{ fontSize: '1.2rem' }}></i>  Agregar a favoritos</Dropdown.Item>}
                    </Dropdown.Menu>
                  </Dropdown>
            </div>
          </div>
        </div>
      )}

      {gridConfig && (
        <div 
          className="dashboard-grid-container"
          style={{
            gridTemplateRows: gridConfig.Rows,
            gridTemplateColumns: gridConfig.Cols,
            gap: gridConfig.Gap,
            padding: gridConfig.Padding,
            height: gridConfig.height,
          }}
        >
          {chartItems.map((item, index) => {
            // Obtener configuración del grid para Cards
            const cardGridConfig = item.type === "Card" ? item.rawItem.ItemData?.Grid : null;
            const hasGridConfig = !!cardGridConfig;
            
            // Si es Card y NO tiene Grid, usar flex (estructura antigua)
            const useFlexLayout = item.type === "Card" && !hasGridConfig;
            
            return (
              <div
                key={index}
                style={{ 
                  width: "100%", 
                  // Cards sin grid necesitan altura automática para expandirse, otros tipos usan 100%
                  height: useFlexLayout ? "auto" : "100%", 
                  gridRow: item.gridRow, 
                  gridColumn: item.gridCol,
                  position: "relative"
                }}
              >
                <div 
                   className={`bg-white shadow ${item.type === "Card" || item.type === "Pies" || item.type === "Spline" || item.type === "Stacked" || item.type === "Clustered" || item.type === "StackedBar" ? "" : "custom-flex"}`}
                   style={{ 
                     borderRadius: 15,
                     // Cards con grid mantienen 100%, otros ajustan según el contenido
                     height: "100%",
                     position: "relative",
                     // Aplicar grid interno solo para Cards con configuración de Grid
                     ...(hasGridConfig ? {
                       display: 'grid',
                       gridTemplateRows: cardGridConfig.Rows || 'repeat(1, 1fr)',
                       gridTemplateColumns: cardGridConfig.Cols || 'repeat(12, 1fr)',
                       gap: cardGridConfig.Gap || '10px',
                       padding: cardGridConfig.Padding || '10px',
                       backgroundColor: cardGridConfig.background || '#ffffff',
                     } : useFlexLayout ? {
                       display: 'flex',
                       flexDirection: 'column',
                       gap: '10px',
                       padding: '10px',
                       justifyContent: 'space-between',
                     } : {})
                   }}
                 >
                   {/* Renderizado condicional según el tipo */}
                   {item.type === "Card" && renderCardItem(item.rawItem, hasGridConfig)}
                   {item.type === "Pies" && renderPiesItem(item.rawItem, true, () => openChartMaximized(index))}
                   
                   {item.type === "Spline" && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px 0 16px', width: '100%' }}>
                        <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.title}</h5>
                        <CustomMaximizeButton onClick={() => openChartMaximized(index)} />
                      </div>
                      <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
                        {renderSplineChart(item.data, item.seriesConfig)}
                      </div>
                    </>
                   )}
                   
                   {item.type === "Stacked" && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px 0 16px', width: '100%' }}>
                        <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.title}</h5>
                        <CustomMaximizeButton onClick={() => openChartMaximized(index)} />
                      </div>
                      <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
                        {renderStackedChart(item.data, item.seriesConfig)}
                      </div>
                    </>
                   )}
                   
                   {item.type === "Clustered" && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px 0 16px', width: '100%' }}>
                        <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.title}</h5>
                        <CustomMaximizeButton onClick={() => openChartMaximized(index)} />
                      </div>
                      <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
                        {renderClusteredChart(item.data, item.seriesConfig)}
                      </div>
                    </>
                   )}
                   
                   {item.type === "StackedBar" && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px 0 16px', width: '100%' }}>
                        <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.title}</h5>
                        <CustomMaximizeButton onClick={() => openChartMaximized(index)} />
                      </div>
                      <div style={{ flex: 1, minHeight: 0, padding: item.itemPadding || "16px" }}>
                        {renderStackedBarItem(item.rawItem)}
                      </div>
                    </>
                   )}
                   
                   {item.type !== "Card" && item.type !== "Pies" && item.type !== "Spline" && item.type !== "Stacked" && item.type !== "Clustered" && item.type !== "StackedBar" && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px 0 16px', width: '100%' }}>
                        <h5 className="chart-title mb-0" style={{ fontWeight: 700, fontSize: "14px", flex: 1, textAlign: 'center' }}>{item.title}</h5>
                        <CustomMaximizeButton onClick={() => openChartMaximized(index)} />
                      </div>
                      <div style={{ 
                        flex: 1, 
                        minHeight: 0, 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        width: "100%",
                        padding: item.type === "Pie" && item.rawItem ? getItemProperties(item.rawItem, "Card").ItemPadding : undefined
                      }}>
                        {item.type === "Pie" && item.rawItem && <CustomPieChart 
                          data={item.data} 
                          fontColor={item.isEstado ? undefined : "#FFFFFF"} 
                          properties={getItemProperties(item.rawItem, "Card")}
                        />}
                        {item.type === "ClusteredStacked" && <CustomBarChart chartData={item.data} seriesConfig={item.seriesConfig} />}
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal para maximizar gráficos */}
      {isChartMaximized && chartsForNavigation.length > 0 && (
        <Modal
          show={isChartMaximized}
          onHide={closeChartMaximized}
          size="xl"
          fullscreen={true}
          centered
          className="chart-maximized-modal"
          style={{ zIndex: 9999 }}
        >
          <Modal.Header style={{ backgroundColor: breadcrumbColor, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Modal.Title>
              {formTitle} - {chartsForNavigation[currentChartIndex]?.title}
            </Modal.Title>
            <div style={{ display: 'flex', alignItems: 'center', gap: '60px' }}>
              {/* Switch de Activar Secuencia */}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ fontSize: '14px', color: '#495057', fontWeight: '500', width: '125px' }}>
                  Activar Secuencia
                </span>
                <label style={{ 
                  position: 'relative', 
                  display: 'inline-block', 
                  width: '50px', 
                  height: '24px',
                  cursor: 'pointer'
                }}>
                  <input 
                    type="checkbox"
                    checked={isAutoPlayActive}
                    onChange={(e) => setIsAutoPlayActive(e.target.checked)}
                    style={{ opacity: 0, width: 0, height: 0 }}
                  />
                  <span style={{
                    position: 'absolute',
                    cursor: 'pointer',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: isAutoPlayActive ? '#007bff' : '#ccc',
                    transition: '0.4s',
                    borderRadius: '24px'
                  }}>
                    <span style={{
                      position: 'absolute',
                      content: '',
                      height: '18px',
                      width: '18px',
                      left: isAutoPlayActive ? '29px' : '3px',
                      bottom: '3px',
                      backgroundColor: 'white',
                      transition: '0.4s',
                      borderRadius: '50%'
                    }}></span>
                  </span>
                </label>
              </div>
              <CustomCloseButton onClose={closeChartMaximized} />
            </div>
          </Modal.Header>
          <Modal.Body style={{ 
            backgroundColor: '#f8f9fa', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            position: 'relative',
            padding: '40px',
            height: 'calc(100vh - 60px)',
            zIndex: 10000
          }}>
            {/* Contenedor del gráfico */}
            {maximizedChartContent}

            {/* Botón Anterior */}
            {chartsForNavigation.length > 1 && (
              <button
                onClick={goToPreviousChart}
                style={{
                  position: 'absolute',
                  left: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '50px',
                  height: '50px',
                  cursor: 'pointer',
                  fontSize: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                  zIndex: 1000
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                  e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                }}
                title="Anterior"
              >
                <i className="fas fa-chevron-left"></i>
              </button>
            )}

            {/* Botón Siguiente */}
            {chartsForNavigation.length > 1 && (
              <button
                onClick={goToNextChart}
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  width: '50px',
                  height: '50px',
                  cursor: 'pointer',
                  fontSize: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                  zIndex: 1000
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                  e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                }}
                title="Siguiente"
              >
                <i className="fas fa-chevron-right"></i>
              </button>
            )}

            {/* Indicador de posición */}
            {chartsForNavigation.length > 1 && (
              <div style={{
                position: 'absolute',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: '500'
              }}>
                {currentChartIndex + 1} / {chartsForNavigation.length}
              </div>
            )}
          </Modal.Body>
        </Modal>
      )}

      {/* Modal de error de la API */}
      <ErrorModal />
    </>
  )
}

export default GenericDashboard